export interface AssessmentQuestion {
  id: string;
  text: string;
}

export const SCALE_LABELS = ['Not at all', 'Several days', 'More than half the days', 'Nearly every day'];

export const GAD7_QUESTIONS: AssessmentQuestion[] = [
  { id: 'g1', text: 'Feeling nervous, anxious, or on edge' },
  { id: 'g2', text: 'Not being able to stop or control worrying' },
  { id: 'g3', text: 'Worrying too much about different things' },
  { id: 'g4', text: 'Trouble relaxing' },
  { id: 'g5', text: 'Being so restless that it\'s hard to sit still' },
  { id: 'g6', text: 'Becoming easily annoyed or irritable' },
  { id: 'g7', text: 'Feeling afraid as if something awful might happen' },
];
